<script>
    import EventEditButton from "./EventEditButton.svelte";
    import Flag from "../flags/Flag.svelte";
    import {getContext} from "svelte";

    let editMode = getContext('editMode');

    export let event;
</script>

<div class="p-2">
    {#each event.event_text as {id, description, language}}
        <EventEditButton {event} id={id} form="text"/>

        {#if $editMode}
            <div class="flag-container">
                <Flag flag={language.code}/>
            </div>
        {/if}
        <div>{description}</div>
        <hr/>
    {/each}
</div>

<style>
    body.bootstrap-dark div {
        color: white;
    }

    .flag-container {
        width: 40px;
    }
</style>